import React from 'react';

export function Footer() {
  return (
    <footer className="py-4 px-6 border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-dark-card">
      <div className="max-w-[1440px] mx-auto text-center">
        <p className="text-sm text-gray-500 dark:text-gray-400">
          designed by neoframe
        </p>
      </div>
    </footer>
  );
}